'use client';

import { useAppContext } from '@/context/app';
import { setCartPageColumn } from '@/util/cart-page-column-storage';

export const useResolvePageColumn = () => {
  const [
    ,
    {
      actions: { setCartActiveColumn },
    },
  ] = useAppContext();

  const resolvePageColumn = cartItems => {
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      setCartActiveColumn('home');
      return;
    }

    const lastCartItemIsAttireCategory = cartItems[cartItems.length - 1]?.product?.categories?.some(
      x => x?.uid === 'NTQ=',
    );

    setCartActiveColumn(lastCartItemIsAttireCategory ? 'attire' : 'home');
    setCartPageColumn(lastCartItemIsAttireCategory ? 'attire' : 'home');
  };

  return { resolvePageColumn };
};
